<template>
  <section class="section">
    <div class="container" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24"> {{ eventTitle }}</span>
        </div>
          
      </div>

      <div class="columns" v-if="isPaid==1">
        <div class="column">
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ຊື່ ແລະ ນາມສະກຸນ: </span><span  class="title16">{{ participateFullname }} </span>
          </b-field>
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ອາຍຸ: </span><span   style="margin-right: 5px;" class="title16">{{ participateAge }} </span> <span  class="title16-light">ປີ </span>
          </b-field>
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ເພດ: </span><span  class="title16">{{ participateGender }} </span>
          </b-field>
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ພາກສ່ວນ: </span><span  class="title16">{{ participateSection }} </span>
          </b-field>
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ເບີໂທ: </span><span  class="title16">{{ participatePhoneNo }} </span>
          </b-field>

          <b-field class="red16bold"> 
            ✅ ຊຳລະເງິນ ສຳເລັດ
          </b-field><br>

          <b-field class="title16"> 
            ນຳໃຊ້ QR ນີ້ເພື່ອ&nbsp;<span class="red16bold">ແຈ້ງເຂົ້າງານ</span>
          </b-field>
            
          <b-field v-if="participateFullname">
            <img :src="qrCodeUrl" alt="QR Code" />
          </b-field>

        </div>
      </div>


      <div class="columns" v-if="isPaid==0">
        <div class="column">
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ຊື່ ແລະ ນາມສະກຸນ: </span><span  class="title16">{{ participateFullname }} </span>
          </b-field>
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ອາຍຸ: </span><span   style="margin-right: 5px;" class="title16">{{ participateAge }} </span> <span  class="title16-light">ປີ </span>
          </b-field>
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ເພດ: </span><span  class="title16">{{ participateGender }} </span>
          </b-field>
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ພາກສ່ວນ: </span><span  class="title16">{{ participateSection }} </span>
          </b-field>
          <b-field>
            <span  class="title16-light" style="margin-right: 10px;">ເບີໂທ: </span><span  class="title16">{{ participatePhoneNo }} </span>
          </b-field>

          

        </div>
      
      </div>
      <div class="columns" v-if="isPaid==0">
        <div class="column">
          <b-field label="ວັນທີຊຳລະເງິນ">
            <b-datepicker
              :date-formatter="dateFormatter"
              v-model="paymentDate"
            >
            </b-datepicker>
          </b-field>
        </div>
        <div class="column">
          
        </div>
      </div>

      <div class="columns" v-if="isPaid==0">
        <div class="column">
          <div class="buttons">
            <b-button
              expanded
              type="is-primary"
              onclick="document.getElementById('fileupload').click()"
              >ເລືອກຮູບ
            </b-button> 
          </div>
        </div>
        <div class="column" >
          <b-button  
              class="btn-group-margin is-fullwidth"
              type="is-success"  
              @click="doPayment(participateID)"
              >  <span > ບັນທຶກການຊຳລະ</span>
          </b-button>
        </div>
      </div>
      <div class="columns" v-if="isPaid==0">
        <div class="column">
          <b-field
            grouped
            position="is-centered"
            v-if="isSelectPhoto || updateAction"
          >
            <img
              data-v-xcxcc
              :src="photopreview"
              width="500"
              height="500"
            />
            <!-- <img data-v-xcxcc src="http://accounting.houngsanaxay.com/accountingapi//khong0.PNG" /> -->
          </b-field>
          <input
            type="file"
            id="fileupload"
            @change="onFileSelected"
            style="visibility:hidden;"
          />
        </div>
      </div>
          
      
    </div>


    

    

    
    
    
  </section>
</template>

<script>
// import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";
import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  // components: { Multiselect },

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,

      
      selectionList: [
        { ID: "1", NAME: "ກະຊວງອຸດສາຫະກຳ ແລະ ການຄ້າ" },
        { ID: "2", NAME: "ກະຊວງກະສິກຳ" },
        { ID: "3", NAME: "ກະຊວງສຶກສາ" },
        { ID: "4", NAME: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ" },
      ],
      selectedFullName: null,
      selectedAge: null,
      selectedGender: null,
      selectedPhoneNo: null,
      selectedSection: null,

      participateID: 12,
      participateFullname: "ທ້າວ ດວງຈັນ ສີພາວັນ",
      participateAge: 34,
      participateGender: "ຊາຍ",
      participateSection: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ",
      participatePhoneNo: "2055333483",
      participateStatus: 2,
      

      eventTitle: "ງານສຳມະນາ ໂອກາດ ເພື່ອກ້າວໄປສູ້ຜູ້ປະກອບການ ແລະ ການຮ່ວມມື ໃນຂະແໜງການກະສິກຳ",

      paymentDate: null,

      fileupload: null,
      selectedFile: null,
      url: "uploadimage", // function name in api site
      photoname: null,
      photopath:
        process.env.NODE_ENV === "production"
          ? "http://139.180.153.118/lababiz/api/uploads/payment/"
          : "http://localhost/lababiz/api/uploads/payment/",
      // photopath: process.env.NODE_ENV === "production" ? "http://51.222.85.54/agrilao-manager/api/uploads/products/" : "http://localhost/agrilao-manager/api/uploads/products/",
      photopreview: null,
      isSelectPhoto: false,

      isPaid: 0,
      
      
    };
     
    
  },
  methods: {     

    doPayment(){
      this.isPaid = 1;
      this.$swal({
        title: "ຊຳລະເງິນ ສຳເລັດແລ້ວ",
        text: "ຊຳລະເງິນ ສຳເລັດແລ້ວ!",
        icon: "success",
        showConfirmButton: true, 
      });
    },
    
    paymentForm(participateID){
      this.activeTab =2;
      console.log("paymentForm: " + participateID)
    },

    onFileSelected(event) {
      this.isSelectPhoto = true;
      // console.log("url: "+ this.url)
      // console.log("photopath: " + this.photopath)
      this.selectedFile = event.target.files[0];
      const fd = new FormData();
      fd.append("image", this.selectedFile);
      axios.post(this.url, fd).then((res) => {
        this.photoname = res.data;
        this.photopreview = this.photopath + res.data;
      });
    },
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      // console.log("photoname: " + photoname)
      // console.log("photopreview: " + photopreview)
      return photopreview;
    },

    register(){
      this.activeTab = 1; 
      this.participateID = 12;
      this.participateFullname = this.selectedFullName;
      this.participateAge = this.selectedAge;
      this.participateGender = this.selectedGender;
      this.participateSection = this.selectedSection.NAME;
      this.participatePhoneNo = this.selectedPhoneNo;

      this.$swal({
        title: "ລົງທະບຽນສຳເລັດ",
        text: "ດຳເນີນການ ສຳເລັດ!",
        icon: "success",
        showConfirmButton: true, 
      });

      this.qrData = this.participateID + " | " + this.participateFullname + " | " + this.participatePhoneNo;

    },
   

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    // this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    // this.username = this.user.USERNAME;   

    this.currentDate = new Date();

    this.paymentDate = new Date(); 

    
    

  
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.qrData)}`;
    },

   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.centered-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;  
  margin-bottom: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content{
  font-size: 16px;
  margin-left: 5px; 
  margin-right: 5px;
}

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}




.container{  
  margin-top: 10px;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-50 {
  flex: 0 0 50%;
}

.column-65 {
  flex: 0 0 65%;
}

.column-35 {
  flex: 0 0 35%;
}

.column-30 {
  flex: 0 0 30%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
